
import * as defaultImport from "@splunk/react-ui/Clickable";
export * from "@splunk/react-ui/Clickable";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
